import { Button } from "@exopengithub/exokit/v2";
import { useTranslation } from "react-i18next";
import type { UseFormReturn } from "react-hook-form";

import { FormSectionContainer } from "src/features/planning/components/formSection/FormSectionContainer";
import { IconArrowRight } from "@tabler/icons-react";
import { Card } from "src/features/planning/components/Card.js";

interface Props {
	form: UseFormReturn<any>;
	disableOnBack?: boolean;
	onBack?: () => void;
	disableOnNextStep?: boolean;
	onNextStep?: () => void;
	disableOnSubmit?: boolean;
	onSubmit?: boolean;
	children?: React.ReactNode | undefined;
}

export const AddDataSourceNavigation = ({
	form,
	disableOnBack,
	onBack,
	disableOnNextStep,
	onNextStep,
	disableOnSubmit,
	onSubmit,
	children,
}: Props) => {
	const { t } = useTranslation();

	return (
		<>
			<Card className="p-6">
				<FormSectionContainer>{children}</FormSectionContainer>
			</Card>
			<div className="mt-4 flex flex-col items-end gap-2">
				{t("By continuing, you allow Exopen to fetch your data")}
				<div className="flex justify-end gap-4">
					{onBack && (
						<Button
							disabled={disableOnBack}
							onClick={onBack}
							variant="secondaryGray"
							type="button"
						>
							{t("Back")}
						</Button>
					)}
					{onNextStep && (
						<Button
							variant="primary"
							type="button"
							disabled={disableOnNextStep}
							onClick={onNextStep}
							icon={<IconArrowRight />}
							iconPosition="trailing"
						>
							{t("Next step")}
						</Button>
					)}
					{onSubmit && (
						<Button
							variant="primary"
							type="submit"
							isLoading={form.formState.isSubmitting}
							disabled={disableOnSubmit}
						>
							{t("Confirm")}
						</Button>
					)}
				</div>
			</div>
		</>
	);
};
